import React from 'react';
import { PageLayout } from '@/shared/layout';
import { AgroKpiDashboard } from './components/AgroKpiDashboard';
import { AgroModulesGrid } from './components/AgroModulesGrid';
import { UpcomingActivities } from './components/UpcomingActivities';
import { AgroAIAssistant } from './components/AgroAIAssistant';

export function AgroPage() {
  return (
    <PageLayout
      title="Agro Center"
      description="Trung tâm điều hành và quản lý dinh dưỡng, phòng trừ sâu bệnh toàn diện"
    >
      <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">

        {/* Top KPIs Dashboard */}
        <AgroKpiDashboard />

        {/* Navigation Hub */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-8 flex flex-col gap-6">
            <div className="flex items-center justify-between">
              <h3 className="text-base font-black text-slate-900 flex items-center gap-2">
                <div className="w-2 h-6 bg-emerald-500 rounded-full" />
                Hệ sinh thái Nông học
              </h3>
            </div>
            <div className="flex-1">
              <AgroModulesGrid />
            </div>
          </div>

          <div className="lg:col-span-4 flex flex-col gap-6">
            <div className="flex items-center justify-between">
              <h3 className="text-base font-black text-slate-900 flex items-center gap-2">
                <div className="w-2 h-6 bg-amber-500 rounded-full" />
                Hoạt động sắp diễn ra
              </h3>
              <button className="text-xs font-medium text-emerald-600 hover:text-emerald-700 hover:underline transition-colors">
                Xem toàn bộ &rarr;
              </button>
            </div>
            <div className="flex-[2] flex flex-col min-h-0">
              <UpcomingActivities />
            </div>

          </div>
        </div>
      </div>
    </PageLayout>
  );
}

export default AgroPage;
